import { render, staticRenderFns } from "./SystemProjectReserve.vue?vue&type=template&id=5c350ea2&"
import script from "./SystemProjectReserve.vue?vue&type=script&lang=js&"
export * from "./SystemProjectReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c350ea2')) {
      api.createRecord('5c350ea2', component.options)
    } else {
      api.reload('5c350ea2', component.options)
    }
    module.hot.accept("./SystemProjectReserve.vue?vue&type=template&id=5c350ea2&", function () {
      api.rerender('5c350ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemProjectReserve.vue"
export default component.exports